import { CustomProgressIndicatorIcon } from 'components/CustomIcon';
import { Configs } from 'interfaces/WidgetConfigs.interface';

enum ICON_TITLE {
  PICK_UP = 'Pick up icon',
  IN_TRANSIT = 'In transit icon',
  CUSTOMS = 'Customs icon',
  OUT_FOR_DELIVERY = 'Out for delivery icon',
  DELIVERED = 'Delivered icon',
  AT_COLLECTION_POINT = 'At collection point icon',
  COLLECTED = 'Collected icon',
  RETURN_TO_SENDER = 'Return to sender icon',
  ISSUE = 'Issue icon',

  // Return
  REQUEST_RETURN = 'Request return icon',
  SELECT_SHIPMENT_METHOD = 'Select shipment method icon',
  RETURN_PRODUCT = 'Return product icon',
  GET_YOUR_REFUND = 'Get your refund icon',
}

// TODO: deprecate Forward - Progress Indicator
export const constructForwardProgressIndicatorTheme = (configs: Configs) => {
  const { tertiaryBox, progressBarBox, fonts } = configs;
  const { progressIndicator: progressIndicatorFontSize } = fonts.fontSize;
  const { colors: iconColors, texts, icons } = progressBarBox;

  const {
    pastEventIconBackground,
    pastEventIconColor,
    pastEventFontColor,
    currentEventIconBackground,
    currentEventIconColor,
    currentEventFontColor,
    futureEventIconBackground,
    futureEventIconColor,
    futureEventFontColor,
    issueEventIconBackground,
    issueEventIconColor,
    issueEventFontColor,
  } = iconColors;

  const {
    pickUpIcon,
    inTransitIcon,
    customsIcon,
    outForDeliveryIcon,
    deliveredIcon,
    atCollectionPointIcon,
    collectedIcon,
    returnToSenderIcon,
    issueIcon,
  } = icons;

  const CustomPickupIcon =
    pickUpIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={pickUpIcon}
        fallback={() => <img src={pickUpIcon} alt={ICON_TITLE.PICK_UP} />}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomInTransitIcon =
    inTransitIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={inTransitIcon}
        fallback={() => <img src={inTransitIcon} alt={ICON_TITLE.IN_TRANSIT} />}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomCustomsIcon =
    customsIcon &&
    (({ color, bgColor }) => {
      return (
        <CustomProgressIndicatorIcon
          src={customsIcon}
          fallback={() => <img src={customsIcon} alt={ICON_TITLE.CUSTOMS} />}
          bgColor={bgColor}
          color={color}
        />
      );
    });

  const CustomOutForDeliveryIcon =
    outForDeliveryIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={outForDeliveryIcon}
        fallback={() => (
          <img src={outForDeliveryIcon} alt={ICON_TITLE.OUT_FOR_DELIVERY} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomDeliveredIcon =
    deliveredIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={deliveredIcon}
        fallback={() => <img src={deliveredIcon} alt={ICON_TITLE.DELIVERED} />}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomAtCollectionPointIcon =
    atCollectionPointIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={atCollectionPointIcon}
        fallback={() => (
          <img
            src={atCollectionPointIcon}
            alt={ICON_TITLE.AT_COLLECTION_POINT}
          />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomCollectedIcon =
    collectedIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={collectedIcon}
        fallback={() => <img src={collectedIcon} alt={ICON_TITLE.COLLECTED} />}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomReturnToSenderIcon =
    returnToSenderIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={returnToSenderIcon}
        fallback={() => (
          <img src={returnToSenderIcon} alt={ICON_TITLE.RETURN_TO_SENDER} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomIssueIcon =
    issueIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={issueIcon}
        fallback={() => <img src={issueIcon} alt={ICON_TITLE.ISSUE} />}
        bgColor={bgColor}
        color={color}
      />
    ));

  return {
    texts,
    icons: {
      CustomPickupIcon,
      CustomCustomsIcon,
      CustomInTransitIcon,
      CustomOutForDeliveryIcon,
      CustomDeliveredIcon,
      CustomAtCollectionPointIcon,
      CustomCollectedIcon,
      CustomReturnToSenderIcon,
      CustomIssueIcon,
    },
    past: {
      iconBgColor: pastEventIconBackground,
      labelColor: pastEventFontColor,
      iconColor: pastEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicatorFontSize,
    },
    current: {
      iconBgColor: currentEventIconBackground,
      labelColor: currentEventFontColor,
      iconColor: currentEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicatorFontSize,
    },
    future: {
      iconBgColor: futureEventIconBackground,
      labelColor: futureEventFontColor,
      iconColor: futureEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicatorFontSize,
    },
    issue: {
      iconBgColor: issueEventIconBackground,
      labelColor: issueEventFontColor,
      iconColor: issueEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicatorFontSize,
    },
  };
};

export const constructReturnProgressIndicatorTheme = (configs: Configs) => {
  const generalProgressBarBox = configs.progressBarBox;
  const returnProgressBarBox = configs.return.progressBarBox;

  const { tertiaryBox, fonts } = configs;
  const { progressIndicator } = fonts.fontSize;
  const { colors } = generalProgressBarBox;
  const { texts, icons } = returnProgressBarBox;

  const {
    pastEventIconBackground,
    futureEventIconBackground,
    currentEventIconBackground,
    currentEventIconColor,
    currentEventFontColor,
    futureEventIconColor,
    futureEventFontColor,
    pastEventIconColor,
    pastEventFontColor,
  } = colors;

  const {
    requestReturnText,
    selectShipmentMethodText,
    returnProductText,
    getYourRefundText,
  } = texts;

  const {
    requestReturnIcon,
    selectShipmentMethodIcon,
    returnProductIcon,
    getYourRefundIcon,
  } = icons;

  const CustomRequestReturnIcon =
    requestReturnIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={requestReturnIcon}
        fallback={() => (
          <img src={requestReturnIcon} alt={ICON_TITLE.REQUEST_RETURN} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomSelectShipmentMethodIcon =
    selectShipmentMethodIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={selectShipmentMethodIcon}
        fallback={() => (
          <img
            src={selectShipmentMethodIcon}
            alt={ICON_TITLE.SELECT_SHIPMENT_METHOD}
          />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomReturnProductIcon =
    returnProductIcon &&
    (({ color, bgColor }) => {
      return (
        <CustomProgressIndicatorIcon
          src={returnProductIcon}
          fallback={() => (
            <img src={returnProductIcon} alt={ICON_TITLE.RETURN_PRODUCT} />
          )}
          bgColor={bgColor}
          color={color}
        />
      );
    });

  const CustomGetYourRefundIcon =
    getYourRefundIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={getYourRefundIcon}
        fallback={() => (
          <img src={getYourRefundIcon} alt={ICON_TITLE.GET_YOUR_REFUND} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  return {
    texts: {
      requestReturnText,
      selectShipmentMethodText,
      returnProductText,
      getYourRefundText,
    },
    icons: {
      CustomRequestReturnIcon,
      CustomSelectShipmentMethodIcon,
      CustomReturnProductIcon,
      CustomGetYourRefundIcon,
    },
    past: {
      iconBgColor: pastEventIconBackground,
      labelColor: pastEventFontColor,
      iconColor: pastEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
    current: {
      iconBgColor: currentEventIconBackground,
      labelColor: currentEventFontColor,
      iconColor: currentEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
    future: {
      iconBgColor: futureEventIconBackground,
      labelColor: futureEventFontColor,
      iconColor: futureEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
    cancelled: {
      iconBgColor: '#898989',
      iconColor: '#fff',
      labelColor: '#898989',
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
  };
};

export const constructPreprintedReturnProgressIndicatorTheme = (
  configs: Configs,
) => {
  const generalProgressBarBox = configs.progressBarBox;
  const returnProgressBarBox = configs.return.progressBarBox;

  const { tertiaryBox, fonts } = configs;
  const { progressIndicator } = fonts.fontSize;
  const { colors } = generalProgressBarBox;
  const { texts, icons } = returnProgressBarBox;

  const {
    pastEventIconBackground,
    futureEventIconBackground,
    currentEventIconBackground,
    currentEventIconColor,
    currentEventFontColor,
    futureEventIconColor,
    futureEventFontColor,
    pastEventIconColor,
    pastEventFontColor,
  } = colors;

  const {
    preprintedPickupText,
    preprintedInTransitText,
    preprintedOutForDeliveryText,
    getYourRefundText: preprintedGetYourRefundText,
  } = texts;

  const {
    preprintedPickupIcon,
    preprintedInTransitIcon,
    preprintedOutForDeliveryIcon,
    getYourRefundIcon: preprintedGetYourRefundIcon,
  } = icons;

  const CustomPreprintedPickupIcon =
    preprintedPickupIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={preprintedPickupIcon}
        fallback={() => (
          <img src={preprintedPickupIcon} alt={ICON_TITLE.PICK_UP} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomPreprintedInTransitIcon =
    preprintedInTransitIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={preprintedInTransitIcon}
        fallback={() => (
          <img src={preprintedInTransitIcon} alt={ICON_TITLE.IN_TRANSIT} />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  const CustomPreprintedOutForDeliveryIcon =
    preprintedOutForDeliveryIcon &&
    (({ color, bgColor }) => {
      return (
        <CustomProgressIndicatorIcon
          src={preprintedOutForDeliveryIcon}
          fallback={() => (
            <img
              src={preprintedOutForDeliveryIcon}
              alt={ICON_TITLE.OUT_FOR_DELIVERY}
            />
          )}
          bgColor={bgColor}
          color={color}
        />
      );
    });

  const CustomPreprintedGetYourRefundIcon =
    preprintedGetYourRefundIcon &&
    (({ color, bgColor }) => (
      <CustomProgressIndicatorIcon
        src={preprintedGetYourRefundIcon}
        fallback={() => (
          <img
            src={preprintedGetYourRefundIcon}
            alt={ICON_TITLE.GET_YOUR_REFUND}
          />
        )}
        bgColor={bgColor}
        color={color}
      />
    ));

  return {
    texts: {
      preprintedPickupText,
      preprintedInTransitText,
      preprintedOutForDeliveryText,
      preprintedGetYourRefundText,
    },
    icons: {
      CustomPreprintedPickupIcon,
      CustomPreprintedInTransitIcon,
      CustomPreprintedOutForDeliveryIcon,
      CustomPreprintedGetYourRefundIcon,
    },
    past: {
      iconBgColor: pastEventIconBackground,
      labelColor: pastEventFontColor,
      iconColor: pastEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
    current: {
      iconBgColor: currentEventIconBackground,
      labelColor: currentEventFontColor,
      iconColor: currentEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
    future: {
      iconBgColor: futureEventIconBackground,
      labelColor: futureEventFontColor,
      iconColor: futureEventIconColor,
      lineColor: tertiaryBox.secondaryFontColor,
      labelFontSize: progressIndicator,
    },
  };
};
